import { render, staticRenderFns } from "./SalesCreate.vue?vue&type=template&id=6f2923a8&scoped=true"
import script from "./SalesCreate.vue?vue&type=script&lang=js"
export * from "./SalesCreate.vue?vue&type=script&lang=js"
import style0 from "./SalesCreate.vue?vue&type=style&index=0&id=6f2923a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2923a8",
  null
  
)

export default component.exports